import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import TsProjectEditComp from "./Component/TsProjectEditComp"


const TsProjectEdit =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TsProjectEditComp />
        </div>
        <Footer />
        </>
    )
}

export default TsProjectEdit